module.exports = __webpack_public_path__ + "img/bt_highlight.29bbac9a.png";